import React from "react";
import { Bar } from "react-chartjs-2";
import CardLayout from "../../../common/cardLayout/CardLayout";
import PatientLoader from "../../../common/PatientLoader";

const ScaredAssessmentGraph = ({
  title,
  labels,
  loading,
  data,
  color = "#1AA8E9",
}) => {
  return (
    <CardLayout
      className="col-sm-12 col-md-6 col-lg-6"
      style={{
        border: "5px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid">
        <div className="d-flex justify-content-start mt-3 mb-5">
          <h6 className="info-card-title">
            <strong>{title}</strong>
          </h6>
        </div>
        <div className="container-fluid p-3 mb-3">
          {loading ? (
            <PatientLoader />
          ) : (
            <Bar
              data={{
                labels,
                datasets: [
                  {
                    label: title,
                    data,
                    backgroundColor: color,
                  },
                ],
              }}
              options={{
                responsive: true,
                plugins: { legend: { display: false } },
                scales: {
                  x: {
                    grid: {
                      display: false,
                    },
                  },
                  y: {
                    beginAtZero: true,

                    type: "linear",

                    grid: {
                      display: true,
                    },
                    ticks: {
                      min: 0,
                      stepSize: 10,
                    },
                  },
                },
              }}
            />
          )}
        </div>
      </div>
    </CardLayout>
  );
};

export default ScaredAssessmentGraph;
